export default function docListReducer( state = {}, action )
{
    switch( action.type )
    {
        case 'DOC_LIST_SUCCEEDED':
            return action.list;

        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/lib/reducers/doc-list.js